/**
 * MARKETING PREDITIVO — VIDEO 6/9 (Revelação)
 * Neon background | 10s | 720x900
 */
import React from "react";
import {AbsoluteFill, useCurrentFrame, interpolate, Easing} from "remotion";
import {FONT_PRESETS} from "../../templates/carrossel/EditorialTechNews";

const CLAMP = {extrapolateLeft: "clamp" as const, extrapolateRight: "clamp" as const};
const fadeIn = (frame: number, start: number, end: number) =>
  interpolate(frame, [start, end], [0, 1], { extrapolateRight: CLAMP });
const slideUp = (frame: number, start: number, end: number, dist = 20) =>
  interpolate(frame, [start, end], [dist, 0], { extrapolateRight: CLAMP, easing: Easing.out(Easing.ease) });

export const MP06Revelacao: React.FC = () => {
  const frame = useCurrentFrame();

  return (
    <AbsoluteFill style={{backgroundColor: "#0a0a0f"}}>
      <div style={{position: "absolute", inset: 0, background: "radial-gradient(ellipse at 50% 30%, #E8454522, transparent 60%)", opacity: 0.15 + Math.sin(frame * 0.04) * 0.05}} />
      <div style={{position: "absolute", top: 30, left: 50, opacity: fadeIn(frame, 0, 10), fontFamily: FONT_PRESETS.mono, fontSize: 13, fontWeight: 500, letterSpacing: 2, textTransform: "uppercase", color: "#666666"}}>MARKETING PREDITIVO</div>
      <div style={{position: "absolute", top: 100, left: 50, opacity: fadeIn(frame, 5, 20), transform: `translateY(${slideUp(frame, 5, 20)})`, fontFamily: FONT_PRESETS.serif, fontSize: 44, fontWeight: 700, lineHeight: 1.15, color: "#FFFFFF", maxWidth: 620}}>Prever não é adivinhar.</div>
      <div style={{position: "absolute", top: 190, left: 50, right: 50, opacity: fadeIn(frame, 15, 30), fontFamily: FONT_PRESETS.serif, fontSize: 22, fontWeight: 400, lineHeight: 1.4, color: "#C8C8FF"}}>É usar dados antigos para saber o que vai acontecer antes de gastar o orçamento.</div>
      {/* Contrast card */}
      <div style={{position: "absolute", top: 320, left: 50, right: 50, opacity: fadeIn(frame, 30, 45), transform: `translateY(${slideUp(frame, 30, 45, 40)})`}}>
        <div style={{background: "#F87171", borderRadius: 12, padding: "16px 20px", marginBottom: 10}}>
          <div style={{fontFamily: FONT_PRESETS.mono, fontSize: 11, fontWeight: 600, color: "#FFFFFF", marginBottom: 4}}>SEM PREVISÃO</div>
          <div style={{fontFamily: FONT_PRESETS.serif, fontSize: 16, fontWeight: 600, color: "#FFFFFF"}}>Gastar → Medir → Ajustar → Repetir (tarde demais)</div>
        </div>
        <div style={{background: "#4ADE80", borderRadius: 12, padding: "16px 20px"}}>
          <div style={{fontFamily: FONT_PRESETS.mono, fontSize: 11, fontWeight: 600, color: "#000000", marginBottom: 4}}>COM PREVISÃO</div>
          <div style={{fontFamily: FONT_PRESETS.serif, fontSize: 16, fontWeight: 600, color: "#000000"}}>Prever → Investir no que vai funcionar (desde o início)</div>
        </div>
      </div>
      <div style={{position: "absolute", bottom: 40, left: 50, right: 50, display: "flex", justifyContent: "space-between", opacity: fadeIn(frame, 40, 50)}}>
        <span style={{fontFamily: FONT_PRESETS.sans, fontSize: 15, color: "#666666"}}>@guilhermeribeiro.ai</span>
        <span style={{fontFamily: FONT_PRESETS.sans, fontSize: 13, color: "#666666"}}>6/9</span>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
